export const metaEntityConfig = {
    groups: {
      exclude: ['entity-groups-pa_status', 'entity-groups-optin_status'],
    },
    businesslines: {
      exclude: ['entity-businesslines-optin_status'],
    },
    clients: {
      exclude: ['entity-clients-optin_status'],
    },
    programs: {
      exclude: [
        'entity-programs-pa_status',
        'entity-programs-optin_status',
        'entity-programs-clinical_criteria',
        'entity-programs-dual_managed',
      ],
    },
    instructions: {
      exclude: [],
    },
    procedures: {
      exclude: [
        'entity-procedures-pa_status',
        'entity-procedures-dual_managed',
        'entity-procedures-effectivedate',
        'entity-procedures-inactivedate',
      ],
    },
    policies: {
      exclude: [
        'entity-policies-pa_status',
        'entity-policies-effectivedate',
        'entity-policies-inactivedate',
      ],
    },
    transactions: {
      exclude: [],
    },
    members: {
      exclude: [],
    },
  };
  export const metaAssociationConfig = {
    policies: {
      policies_version: {
        exclude: [],
      },
      instructions: {
        exclude: [],
      },
      procedures: {
        exclude: ['asso-procedures-dual_managed'],
      },
    },
    groups: {
      programs: {
        exclude: [
          'asso-programs-pa_status',
          'asso-programs-clinical_criteria',
          'asso-programs-dual_managed',
        ],
      },
      businesslines: { exclude: ['asso-businesslines-optin_status'] },
      clients: { exclude: ['asso-clients-optin_status'] },
      instructions: { exclude: [] },
      procedures: { exclude: ['asso-procedures-dual_managed'] },
    },
    businesslines: {
      programs: {
        exclude: [
          'asso-programs-pa_status',
          'asso-programs-clinical_criteria',
          'asso-programs-dual_managed',
        ],
      },
      groups: {
        exclude: [
          'asso-groups-prior_auth_exumption',
          'asso-groups-pa_status',
          'asso-groups-optin_status',
        ],
      },
      instructions: { exclude: [] },
      procedures: { exclude: ['asso-procedures-dual_managed'] },
    },
    clients: {
      programs: {
        exclude: [
          'asso-programs-pa_status',
          'asso-programs-clinical_criteria',
          'asso-programs-dual_managed',
        ],
      },
      groups: {
        exclude: [
          'asso-groups-prior_auth_exumption',
          'asso-groups-pa_status',
          'asso-groups-optin_status',
        ],
      },
      instructions: { exclude: [] },
      procedures: { exclude: ['asso-procedures-dual_managed'] },
    },
    programs: {
      businesslines: { exclude: ['asso-businesslines-prior_auth_exumption'] },
      clients: { exclude: [] },
      groups: {
        exclude: ['asso-groups-prior_auth_exumption', 'asso-groups-pa_status'],
      },
      instructions: { exclude: [] },
      procedures: { exclude: [] },
    },
    instructions: {
      businesslines: { exclude: ['asso-businesslines-optin_status'] },
      clients: { exclude: ['asso-clients-optin_status'] },
      programs: {
        exclude: [
          'asso-programs-pa_status',
          'asso-programs-optin_status',
          'asso-programs-dual_managed',
        ],
      },
      groups: { exclude: ['asso-groups-pa_status', 'asso-groups-optin_status'] },
      policies: {
        exclude: ['asso-policies-pa_status', 'asso-policies-lob_title'],
      },
    },
    procedures: {
      policies: { exclude: ['asso-policies-lob_title'] },
      groups: {
        exclude: ['asso-groups-prior_auth_exumption', 'asso-groups-optin_status'],
      },
      businesslines: {
        exclude: [
          'asso-businesslines-optin_status',
          'asso-businesslines-prior_auth_exumption',
        ],
      },
      clients: { exclude: ['asso-clients-optin_status'] },
      programs: {
        exclude: [
          'asso-programs-clinical_criteria',
          'asso-programs-optin_status',
        ],
      },
    },
  };
  export const operationList = [
    {
      label: "=",
      name: "date"
    },
    {
      label: "<=",
      name: "date_ltq"
    },
    {
      label: ">=",
      name: "date_gtq"
    },
    {
      label: "Between",
      name: "range"
    },
    {
      label: "Month",
      name: "month"
    },
    {
      label: "=",
      name: "equals"
    },
    {
      label: "Between",
      name: "between"
    },
    {
      label: "Like",
      name: "like"
    },
    {
      label: "Includes",
      name: "in"
    },
    // {
    //   label: "Null",
    //   name: "null"
    // },
  ];